import { memoize } from '@bigcommerce/memoize';
import { object, string, ObjectSchema, StringSchema } from 'yup';

import getCustomFormFieldsValidationSchema, { FormFieldsValidationSchemaOptions } from './getCustomFormFieldsValidationSchema';

export const WHITELIST_REGEXP = /^[^<>]*$/;

export interface FormFieldValues {
    [key: string]: string | { [id: string]: any };
}

export default memoize(function getFormFieldsValidationSchema({
    formFields,
    translate = () => undefined,
}: FormFieldsValidationSchemaOptions): ObjectSchema<FormFieldValues> {
    return object({
        ...formFields
            .filter(({ custom }) => !custom)
            .reduce((schema, { name, required, label }) => {
                schema[name] = string();

                if (required) {
                    schema[name] = schema[name].required(translate('required', { label, name }));
                }

                schema[name] = schema[name].matches(
                    WHITELIST_REGEXP,
                    translate('invalid', { name, label })
                );

                return schema;
            },
            {} as { [key: string]: StringSchema }
        ),
    }).concat(getCustomFormFieldsValidationSchema({ formFields, translate })) as ObjectSchema<FormFieldValues>;
});
